import styled from "@emotion/styled";
import React from "react";

import type { ILinkListNavModule, ILinkListLink } from "../../../types";

import LinkListItemDesktop from "./LinkListItemDesktop";
import LinkListItemMobile from "./LinkListItemMobile";

export interface LinkListItemProps
  extends Pick<ILinkListNavModule, "linkModifier" | "modifier"> {
  link: ILinkListLink;
}

const LinkListItemContainer = styled.div(({ theme }) => ({
  "&:hover": {
    "span[data-name='Arrow']": {
      marginLeft: theme.spacing.LRG.xxsml / 2,
      transition: `all ${theme.animations.durationSlow}`,
    },
  },
}));

export function LinkListItem(props: LinkListItemProps) {
  return (
    <LinkListItemContainer>
      <LinkListItemDesktop {...props} />
      <LinkListItemMobile {...props} />
    </LinkListItemContainer>
  );
}
